<template>
    <div class="d-flex align-items-center flex-column flex-md-row p-2 p-md-5">
        <div class="overlay__img--wrapper">
            <img src="@/assets/milestones/milestone__1919.jpg" class="img-fluid overlay__img">
        </div>
        <div class="milestone__info--overlay">
            <div class="milestone__year font-24 text-left">1919</div>
            <div class="milestone__headline font-bold font-32 text-left" v-html="$t('MILESTONE_1919_HEADLINE')">The Shiseido Gallery</div>
            <div class="text-left d-flex flex-column align-items-start mt-3 mt-md-5">
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_1919_TEXT_01')">
                    The Shiseido Gallery for fashion and beauty oriented events, the Gallery served for young artists to show their
                    work. This was the beginning of SHISEIDO's long history as a patron of the arts.
                </div>
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_1919_TEXT_02')">
                    Nearly a century after its opening the SHISEIDO Gallery is the oldest non-profit gallery in Japan.
                </div>
                <div class="milestone__text font-18 mt-4" v-html="$t('MILESTONE_1919_TEXT_03')">
                    Over the years the work of more than 5,000 artists has been displayed in about 3,100 exhibitions,
                    enjoyed by countless millions of visitors
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "milestone-1919",
    }
</script>

<style scoped>

</style>